import { v4 as uid } from 'uuid'

export const getUniqueId = (preKey?: string | number): string =>
  `${preKey ? `${preKey}_` : ''}${uid()}`
